import React, { useEffect, useState } from "react";
import { get_proveedores } from "../../../actions/produccion";
import { SearchBasicSelectUI } from "../../ui/SearchBasicSelectUI";
export const ProveedorSelect = ({ ...props }) => {
  const [options, setOptions] = useState([]);
  const OnLoadDatos = async () => {
    const datos = await get_proveedores();
    setOptions(datos);
  };
  useEffect(() => {
    OnLoadDatos();
  }, []);

  return <SearchBasicSelectUI data={options} {...props} />;
};
